import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentOrderStudentId } from '../../../../../hooks/useCurrentOrderStudentId';
import { declineInterstitialProduct } from '../../../../../actions/v3Order';

const DeclineInterstitialProductButton = () => {
  const dispatch = useDispatch();
  const product = useSelector((state) => state.productConfig.currentProduct);
  const studentId = useCurrentOrderStudentId();

  if (!product) return null;

  return (
    <div
      className="bnl-product-config__button--cancel button bg--dark-grey"
      onClick={() => {
        dispatch(declineInterstitialProduct(studentId, product.id));
      }}
    >
      No Thanks
    </div>
  );
};

export default DeclineInterstitialProductButton;
